export { default } from "./interaction-icon";
